<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.editcoursecontent") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ $t("PLACEHOLDERS.choose_type") }}</h3>

            <div class="type-selector">
              <label
                class="custom-radio"
                :class="{ selected: data.type === 'lecture' }"
              >
                <input type="radio" value="lecture" v-model="data.type" />
                <span class="radio-label">{{
                  $t("PLACEHOLDERS.lecture")
                }}</span>
              </label>

              <label
                class="custom-radio"
                :class="{ selected: data.type === 'exam' }"
              >
                <input type="radio" value="exam" v-model="data.type" />
                <span class="radio-label">{{ $t("PLACEHOLDERS.exam") }}</span>
              </label>
            </div>
          </div>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.lecture_video')"
            v-model.trim="data.video"
            required
            v-if="data.type === 'lecture'"
          />
          <base-select-input
            v-if="data.type === 'exam'"
            col="6"
            :placeholder="$t('PLACEHOLDERS.exam')"
            v-model.trim="data.exam"
            :optionsList="exams"
            required
          />
          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.course')"
            v-model.trim="data.course"
            :optionsList="courses"
            required
          />
          <base-select-input
            col="6"
            :placeholder="$t('PLACEHOLDERS.class_name')"
            v-model.trim="data.class"
            :optionsList="classes"
            v-if="classes"
            required
          />

          <base-input
            col="6"
            v-if="data.type === 'lecture'"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionOnlyEn')"
            v-model.trim="data.description"
            required
          />
          <div class="col-lg-6" v-if="data.type === 'lecture'">
            <h3 class="heading">{{ $t("PLACEHOLDERS.resources") }}</h3>
            <FileUpload
              :multiple="true"
              :accept="'application/pdf,image/*,video/*'"
              :urls="preparedUrls"
              @onFileSelect="handleFileSelect"
              @onFileRemove="handleFileRemove"
            />
          </div>
          <div
            v-if="data.type === 'lecture'"
            class="input_wrapper switch_wrapper my-5 col-6"
          >
            <v-switch
              color="green"
              :label="
                data.can_read
                  ? $t('PLACEHOLDERS.enable_read')
                  : $t('PLACEHOLDERS.disabled_read')
              "
              v-model="data.can_read"
              hide-details
            ></v-switch>
          </div>

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FileUpload from "../../../components/formInputs/FileUpload.vue";

export default {
  name: "Editcourse-contents",
  components: { FileUpload },

  data() {
    return {
      isInitialCourseChange: true,
      isWaitingRequest: false,
      preparedUrls: [],
      file: null,
      rawSources: [],
      fileType: "",
      courses: [],
      classes: [],
      exams: [],
      data: {
        exam: null,
        name_ar: null,
        type: "",
        name_en: null,
        video: null,
        course: null,
        description: "",
        class: null,
        can_read: true,
      

},
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },
  watch: {
    "data.course"(newVal) {
      if (this.isInitialCourseChange) {
        this.isInitialCourseChange = false;
        return;
      }

      this.data.class = null;

      if (newVal) this.getClasses(newVal);
    },
    "data.description"(newVal) {
      const onlyEnglish = newVal.replace(
        /[^a-zA-Z0-9 .,!?'"()\[\]{}\-_:;@#$/\\%^&*+=~`<>|\n\r]/g,
        ""
      );
      this.$nextTick(() => {
        this.data.description = onlyEnglish;
      });
    },
  },
  methods: {
    handleFileRemove(index) {
      const totalOld = this.preparedUrls.length;
      console.log(index, totalOld);
      if (index < totalOld) {
        const removedUrl = this.preparedUrls[index];
        const removedFileObj = this.rawSources.find(
          (f) => f.source === removedUrl
        );
        console.log(removedUrl, removedFileObj);
        this.preparedUrls.splice(index, 1);
        this.rawSources = this.rawSources.filter(
          (f) => f.source !== removedUrl
        );

        if (removedFileObj) {
          this.deleteFileFromServer(removedFileObj.id);
        }
      } else {
        const fileIndex = index - totalOld;
        this.selectedFiles.splice(fileIndex, 1);
      }
    },
    deleteFileFromServer(id) {
      console.log("Send request to delete file with ID:", id);
      axios.delete(`/api/files/${id}`);
    },
    handleFileSelect(files) {
      this.selectedFiles = files;
    },

    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("type", this.data.type);
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.course) {
        REQUEST_DATA.append("course_id", this.data.course.id);
      }
      if (this.data.class) {
        REQUEST_DATA.append("class_name_id", this.data.class.id);
      }
      if (this.data.type === "lecture") {
        if (this.data.description) {
          REQUEST_DATA.append("description", this.data.description);
        }
        if (this.data.video) {
          REQUEST_DATA.append("video_url", this.data.video);
        }
        this?.selectedFiles?.forEach((file, i) => {
          REQUEST_DATA.append(`sources[${i}]`, file);
        });
        REQUEST_DATA.append("can_read", this.data.can_read ? 1 : 0);
      }
      if (this.data.type === "exam" && this.data.exam) {
        REQUEST_DATA.append("exam_id", this.data.exam.id);
      }
      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `course-contents/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/coursecontents/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showCourse() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `course-contents/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.CourseContent.name_ar;
        this.data.name_en = res.data.data.CourseContent.name_en;
        this.data.description = res.data.data.CourseContent.description;
        this.data.name_en = res.data.data.CourseContent.name_en;
        this.data.type = res.data.data.CourseContent.type;
        this.data.course = res.data.data.CourseContent.course;
        this.getClasses(this.data.course);
        this.data.class = res.data.data.CourseContent.class_name;
        this.data.exam = res.data.data.CourseContent.exam;

        this.data.can_read = res.data.data.CourseContent.can_read;

        this.data.video = res.data.data.CourseContent.video_url;
        this.preparedUrls = res.data.data.CourseContent.sources.map(
          (item) => item.source
        );

        this.data.active = res.data.data.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    async getCourses() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "courses?page=0&limit=0&is_active=1",
        });
        this.courses = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getClasses(course) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `class-names?page=0&limit=0&is_active=1&course_id=${course.id}`,
        });
        this.classes = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getExams() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `exams?page=0&limit=0&is_active=1`,
        });
        this.exams = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    this.showCourse();
    this.getCourses();
    this.getExams();
  },
};
</script>
